<mat-card class="ecart-card">
  <mat-card-title>Détail de l'incident</mat-card-title>

  <div class="buttonAffranchir">
    <button mat-stroked-button (click)="affranchirIncident()">
      Affranchir l'incident
    </button>
  </div>

  <mat-card-content *ngIf="typeEcart && valeurEcart !== null">
    <div class="comparison-container">
      @if (incident.typeIncident?.codeTypeIncident === 'EBIT') {
      <ng-container [ngSwitch]="typeEcart">
        <!-- Poste -->
        <div *ngSwitchCase="'ecartPoste'" class="comparison-section">
          <h3>Postes</h3>
          <div class="comparison-grid">
            <div class="source">
              <label>BitDefender</label>
              <span>{{ incident.comparison?.bitData?.nbPostes }}</span>
            </div>
            <div class="source">
              <label>Divalto</label>
              <span>{{ incident.comparison?.divaltoData?.nbPostes }}</span>
            </div>
          </div>
          <div class="ecart-value">Écart : {{ valeurEcart }}</div>
        </div>

        <!-- Serveur -->
        <div *ngSwitchCase="'ecartServeur'" class="comparison-section">
          <h3>Serveurs</h3>
          <div class="comparison-grid">
            <div class="source">
              <label>BitDefender</label>
              <span>{{ incident.comparison?.bitData?.nbServeurs }}</span>
            </div>
            <div class="source">
              <label>Divalto</label>
              <span>{{ incident.comparison?.divaltoData?.nbServeurs }}</span>
            </div>
          </div>
          <div class="ecart-value">Écart : {{ valeurEcart }}</div>
        </div>

        <!-- Autres cas EBIT : ATS / EDR / MDR / CRY / PATCH -->
        <div *ngSwitchCase="'ecartAts'" class="comparison-section">
          <h3>Modules ATS</h3>
          <div class="comparison-grid">
            <div class="source">
              <label>BitDefender</label>
              <span>{{ incident.comparison?.bitData?.nbAts }}</span>
            </div>
            <div class="source">
              <label>Divalto</label>
              <span>{{ incident.comparison?.divaltoData?.nbAts }}</span>
            </div>
          </div>
          <div class="ecart-value">Écart : {{ valeurEcart }}</div>
        </div>
        <div *ngSwitchCase="'ecartEdr'" class="comparison-section">
          <h3>Modules EDR</h3>
          <div class="comparison-grid">
            <div class="source">
              <label>BitDefender</label>
              <span>{{ incident.comparison?.bitData?.nbEdr }}</span>
            </div>
            <div class="source">
              <label>Divalto</label>
              <span>{{ incident.comparison?.divaltoData?.nbEdr }}</span>
            </div>
          </div>
          <div class="ecart-value">Écart : {{ valeurEcart }}</div>
        </div>
        <div *ngSwitchCase="'ecartMdr'" class="comparison-section">
          <h3>Modules MDR</h3>
          <div class="comparison-grid">
            <div class="source">
              <label>BitDefender</label>
              <span>{{ incident.comparison?.bitData?.nbMdr }}</span>
            </div>
            <div class="source">
              <label>Divalto</label>
              <span>{{ incident.comparison?.divaltoData?.nbMdr }}</span>
            </div>
          </div>
          <div class="ecart-value">Écart : {{ valeurEcart }}</div>
        </div>
        <div *ngSwitchCase="'ecartCry'" class="comparison-section">
          <h3>Modules CRY</h3>
          <div class="comparison-grid">
            <div class="source">
              <label>BitDefender</label>
              <span>{{ incident.comparison?.bitData?.nbCry }}</span>
            </div>
            <div class="source">
              <label>Divalto</label>
              <span>{{ incident.comparison?.divaltoData?.nbCry }}</span>
            </div>
          </div>
          <div class="ecart-value">Écart : {{ valeurEcart }}</div>
        </div>
        <div *ngSwitchCase="'ecartPatch'" class="comparison-section">
          <h3>Modules PATCH</h3>
          <div class="comparison-grid">
            <div class="source">
              <label>BitDefender</label>
              <span>{{ incident.comparison?.bitData?.nbPatch }}</span>
            </div>
            <div class="source">
              <label>Divalto</label>
              <span>{{ incident.comparison?.divaltoData?.nbPatch }}</span>
            </div>
          </div>
          <div class="ecart-value">Écart : {{ valeurEcart }}</div>
        </div>

        <!-- Répète la même structure pour EDR / MDR / CRY / PATCH si nécessaire -->
      </ng-container>
      } @if (incident.typeIncident?.codeTypeIncident === 'ERG') {
      <ng-container [ngSwitch]="typeEcart">
        <div *ngSwitchCase="'ecartPoste'" class="comparison-section">
          <h3>Postes</h3>
          <div class="comparison-grid">
            <div class="source">
              <label>RG</label>
              <span>{{ incident.comparison?.rgData?.nbPostes }}</span>
            </div>
            <div class="source">
              <label>Divalto</label>
              <span>{{ incident.comparison?.divaltoData?.nbPostes }}</span>
            </div>
          </div>
          <div class="ecart-value">Écart : {{ valeurEcart }}</div>
        </div>

        <div *ngSwitchCase="'ecartServeur'" class="comparison-section">
          <h3>Serveurs</h3>
          <div class="comparison-grid">
            <div class="source">
              <label>RG</label>
              <span>{{ incident.comparison?.rgData?.nbServeurs }}</span>
            </div>
            <div class="source">
              <label>Divalto</label>
              <span>{{ incident.comparison?.divaltoData?.nbServeurs }}</span>
            </div>
          </div>
          <div class="ecart-value">Écart : {{ valeurEcart }}</div>
        </div>

        <div *ngSwitchCase="'ecartEquipement'" class="comparison-section">
          <h3>Équipements</h3>
          <div class="comparison-grid">
            <div class="source">
              <label>RG</label>
              <span>{{ incident.comparison?.rgData?.nbEquipements }}</span>
            </div>
            <div class="source">
              <label>Divalto</label>
              <span>{{ incident.comparison?.divaltoData?.nbEquipements }}</span>
            </div>
          </div>
          <div class="ecart-value">Écart : {{ valeurEcart }}</div>
        </div>
      </ng-container>
      }
    </div>

    <div class="comparison-section" style="margin-top: 16px">
      <h3>Description</h3>
      <div>
        {{ incident.description }}
      </div>
    </div>

    <div class="statutSelect">
      <form [formGroup]="form">
        <mat-form-field appearance="fill">
          <mat-label>Statut de l'incident</mat-label>
          <mat-select
            [(ngModel)]="incident.statutIncident"
            name="statut"
            [compareWith]="compareFn"
            formControlName="statutIncident"
          >
            <mat-option *ngFor="let statut of statuts" [value]="statut">
              {{ statut.libelle }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </form>
    </div>
  </mat-card-content>
  <mat-card-content
    *ngIf="
      !typeEcart && (incident.deviceBit != null || incident.deviceRg != null)
    "
  >
    <div
      *ngIf="incident.deviceRg && incident.deviceRg.type?.code == 'POS'"
      class="comparison-section"
      style="margin-top: 16px"
    >
      <h3>Poste RG non présent dans BitDefender</h3>
      <div style="text-align: center">
        {{ incident.deviceRg.nomAgent }}
      </div>
    </div>

    <div
      *ngIf="incident.deviceRg && incident.deviceRg.type?.code == 'SERV'"
      class="comparison-section"
      style="margin-top: 16px"
    >
      <h3>Serveur RG non présent dans BitDefender</h3>
      <div style="text-align: center">
        {{ incident.deviceRg.nomAgent }}
      </div>
    </div>

    <div
      *ngIf="incident.deviceBit && incident.deviceBit.type?.code == 'POS'"
      class="comparison-section"
      style="margin-top: 16px"
    >
      <h3>Poste BitDefender non présent dans RG</h3>
      <div style="text-align: center">
        {{ incident.deviceBit.nom }}
      </div>
    </div>

    <div
      *ngIf="incident.deviceBit && incident.deviceBit.type?.code == 'SERV'"
      class="comparison-section"
      style="margin-top: 16px"
    >
      <h3>Serveur BitDefender non présent dans RG</h3>
      <div style="text-align: center">
        {{ incident.deviceBit.nom }}
      </div>
    </div>

    <div class="comparison-section" style="margin-top: 16px">
      <h3>Description</h3>
      <div>
        {{ incident.description }}
      </div>
    </div>

    <div class="statutSelect">
      <form [formGroup]="form">
        <mat-form-field appearance="fill">
          <mat-label>Statut de l'incident</mat-label>
          <mat-select
            [(ngModel)]="incident.statutIncident"
            name="statut"
            [compareWith]="compareFn"
            formControlName="statutIncident"
          >
            <mat-option *ngFor="let statut of statuts" [value]="statut">
              {{ statut.libelle }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </form>
    </div>
  </mat-card-content>

  <mat-card-content
    *ngIf="
      !typeEcart &&
      incident.deviceBit == null &&
      incident.deviceRg == null &&
      (incident.clientBitMissing != null || incident.clientRgMissing != null)
    "
  >
    <div
      *ngIf="incident.clientBitMissing != null"
      class="comparison-section"
      style="margin-top: 16px"
    >
      <h3>Client BitDefender non présent dans la table de correspondance</h3>
      <div style="text-align: center">
        {{ incident.clientBitMissing }}
      </div>
    </div>

    <div
      *ngIf="incident.clientRgMissing != null"
      class="comparison-section"
      style="margin-top: 16px"
    >
      <h3>Client RG non présent dans la table de correspondance</h3>
      <div style="text-align: center">
        {{ incident.clientRgMissing }}
      </div>
    </div>
    <div class="comparison-section" style="margin-top: 16px">
      <h3>Description</h3>
      <div>
        {{ incident.description }}
      </div>
    </div>

    <div class="statutSelect">
      <form [formGroup]="form">
        <mat-form-field appearance="fill">
          <mat-label>Statut de l'incident</mat-label>
          <mat-select
            [(ngModel)]="incident.statutIncident"
            name="statut"
            [compareWith]="compareFn"
            formControlName="statutIncident"
          >
            <mat-option *ngFor="let statut of statuts" [value]="statut">
              {{ statut.libelle }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </form>
    </div>
  </mat-card-content>

  <div class="row" style="margin-top: 16px" mat-dialog-actions>
    <button
      mat-raised-button
      color="warn"
      style="width: 40%"
      mat-dialog-close
      (click)="cancelButton()"
    >
      Annuler
    </button>
    <button
      mat-raised-button
      color="primary"
      mat-dialog-close
      type="submit"
      style="width: 40%"
      (click)="validateButton()"
      [disabled]="!form.dirty || form.invalid"
    >
      Valider
    </button>
  </div>
</mat-card>
